export const EVENT_SEEK_STEPS = {
    playerLeft: -30,
    playerRight: 30,
};
